export default __webpack_public_path__ + "assets/images/image-tickets.5e006566.png";